module.exports = __webpack_public_path__ + "5c666db475a93cf8b96dc0b7e2d94e1a.png";